import React, {Component} from 'react'
import '../../styles/Admin.css'
import {Tab, Tabs} from "react-bootstrap-tabs";
import Zarzadzanie from "./aktualnosciComponents/Zarzadzanie";
import NowyWpis from "./aktualnosciComponents/NowyWpis";
import EdytujSlajd from "./aktualnosciComponents/EdytujWpis";
import AdminPanel from "../AdminPanel";
// import '../../styles/Tabs.css'

export default class AdminAktualnosci extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedItem: '',
            title: '',
            selectedIndex: 0
        }
    }

    render() {
        return <AdminPanel>
            <div className="componentContainer">
                <h5 style={{paddingLeft: 10}}>Aktualności</h5>
                <hr/>
                <Tabs selected={this.state.selectedIndex} onSelect={(index, label) => {
                    this.setState({selectedIndex: index});
                }}>
                    <Tab label={'Zarządzanie'}>
                        <Zarzadzanie goNowyWpis={() => this.setState({selectedIndex: 1})}
                                     goEdycja={() => this.setState({selectedIndex: 2})}
                                     setItem={(item) => this.setState({selectedItem: item, title: item.tytul})}/>
                    </Tab>
                    <Tab label={'Nowy wpis'}>
                        <NowyWpis goZarzadzanie={() => this.setState({selectedIndex: 0})}/>
                    </Tab>
                    <Tab label={this.state.title} disabled={this.state.selectedIndex !== 2}>
                        <EdytujSlajd item={this.state.selectedItem}
                                     goZarzadzanie={() => this.setState({selectedIndex: 0})}/>
                    </Tab>
                </Tabs>
            </div>
        </AdminPanel>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/AdminAktualnosci.js